import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ApiRestService} from "../../_service/api-rest.service";
import {ApiRestService as PersonaleApiRestService} from "../../../Admin/_service/api-rest.service";
import {Persona} from "../../../Admin/models/persona";
import {InterventiTecnico} from "../../../Interventi/Models/InterventiTecnico";
import {DatePipe} from "@angular/common";
import {RicercaPaginazione} from "../../../Admin/models/sendpersonale";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {Intervento} from "../../../Interventi/Models/Intervento";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AttivitaTaskEditComponent} from "../attivita-edit/attivita-task-edit.component";
import { Task } from '../../models/Task';
import {ActivatedRoute, Router} from "@angular/router";
import { environment } from 'src/environments/environment';
import {ApiPathsService} from "../../../api-paths.service";
import {IDropdownSettings} from "../../../../LibrerieCustom/MultiselectDropdown";
import { AttivitaGanttComponent } from '../attivita-gantt/attivita-gantt.component';

@Component({
  selector: 'app-attivita-list',
  templateUrl: './attivita-list.component.html'
})
export class AttivitaListComponent implements OnInit {
  @ViewChild('ganttTab') gantt: AttivitaGanttComponent;
  utentidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  clientidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'nominativo',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  closedDS:IDropdownSettings ={
    singleSelection: true,
    singleOutput:true,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'label',
  };
  prodottidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'seriale',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  clientiselezionati: any;
  clienti: any;
  environment=environment;
  List: Intervento[];
  managers: Persona[] = [];
  managerselezionati: Persona[] = [];
  InterventiTecnici: InterventiTecnico[];
  today = new Date();
  mese = this.today.getMonth();
  anno = this.today.getFullYear();
  prodotti: any = [];
  prodottiselezionati: any[];
  tipoObject: { id: any };
  tipi:[] = [];
  protected readonly closed = closed;
  closedf: {id: boolean, label:string} = {id: false, label:'Non Chiuso'};
  Approvato: {id: boolean, label:string} = null
  periodo: boolean = true;
  @Input() giorno: string = this.datepipe.transform(this.today, 'yyyy-MM-dd');
  inizio: string = this.datepipe.transform(new Date(this.anno,this.mese,1), 'yyyy-MM-dd');
  fine: string = this.datepipe.transform(new Date(this.anno,this.mese+1,0), 'yyyy-MM-dd');
  Stampe: any[];
  filtro: {};
  constructor(
    private apiRestService: ApiRestService,
    private personaleApiRestService: PersonaleApiRestService,
    private datepipe: DatePipe,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private apiPaths: ApiPathsService
  ) { }
  ActiveId: string = 'Lista';


  ngOnInit(): void {
    this.ActiveId = localStorage.getItem('taskboardActiveId');
    this.getTipi();
  }

  activeIdChange() {
    localStorage.setItem('taskboardActiveId', this.ActiveId);


    
  }



  refresh(filter? :any){
    var val: number[]=[];
    this.managerselezionati?.forEach(element => val.push(element.id));
    //this.apiRestService.getAttivitaTecnici(this.inizio, this.fine, val).subscribe(data => this.InterventiTecnici = data);
    var filtro = filter ?? {page: 0, size: 10, chiuso: this.closedf?.id, tipo: this.tipoObject?.id, approvazione: this.Approvato?.id, inizio: this.periodo ? this.inizio: null, fine: this.periodo ? this.fine : null, periodo: this.periodo, tecnici: this.managerselezionati?.map(x=>x.id), clienti: this.clientiselezionati?.map(x=>x.id), prove: this.prodottiselezionati?.map(x=>x.id)};
    this.apiPaths.ClassicPost('/rma/interventi/day', Object.assign({}, this.filtro ?? {}, filtro)).subscribe(data => {
      this.InterventiTecnici = data;
    })
    this.apiRestService.getAttivita(Object.assign({}, this.filtro ?? {}, filtro, {assegnare:true})).subscribe(data=>{
      this.List = data?.data ?? [];
      this.Stampe = data?.stampe ?? [];
    })
  }
  filtroResponsabile(item: string) {
    if (item.length >= 3) {
      this.personaleApiRestService.getListaPersonale(new RicercaPaginazione(item, 0, 1)).subscribe(data=>{
        this.managers = data?.data;
      });
    }
  }
  getTipi(){
    this.apiPaths.ClassicPost('/settings/get', {id: "tipo_intervento", type:"tipo_intervento"}).subscribe(data => {
      this.tipi = data;
    })
  }
  filtroProdotti(s: string = "") {
    this.refresh();
    if(this.clientiselezionati?.find(x=>true).id)
      this.apiRestService.getProveAcquistoCliente({id:this.clientiselezionati?.find(x=>true).id}).subscribe(data=>this.prodotti = data?.data);
  }
  filtroCliente(event: string) {
    if (event.length >= 3)
      this.personaleApiRestService.getListaAziende(new RicercaPaginazione(event, 0, 1)).subscribe(data=>this.clienti = data?.data);
  }
  drop(event: CdkDragDrop<Intervento[]>, lista?) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    if(lista){
      event.container.data[event.currentIndex].manager = lista.id;
      //event.container.data[event.currentIndex].data_inizio_effettiva = this.datepipe.transform(this.today, 'yyyy-MM-ddTHH:mm');
      this.apiRestService.updateAttivita(event.container.data[event.currentIndex]).subscribe()
    }
  }

  Edit(task?: Task) {
    let editmodal = this.modalService.open(AttivitaTaskEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<AttivitaTaskEditComponent>editmodal.componentInstance).IsModal = true;
    (<AttivitaTaskEditComponent>editmodal.componentInstance).Item = task ?? new Task();
    (<AttivitaTaskEditComponent>editmodal.componentInstance).updated.subscribe(data=> {this.refresh()});
  }
  GetShortText(string: string){
    if(!string) return "";
    var stringaSplittata = string.split('fine ticket')
    return stringaSplittata[0].slice(0, 200)
  }

  OpenGantt() {
    this.router.navigate([this.route.snapshot.queryParams[' task/attivita/gantt '] || 'task/attivita/gantt',]);
  }

  Delete(item) {
    if(confirm("Sei sicuro di voler eliminare questo elemento?"))
    this.apiRestService.deleteAttivita(item).subscribe(()=>{
      this.refresh();
    })
  }
  LeggiMail(){
    this.apiRestService.LeggiEmailAttivita().subscribe(()=> this.refresh())
  }
}
